<template>
    <select>
        <slot></slot>
    </select>
</template>
<script>
    import $ from 'jquery';
    import 'select2';

    export default {
        props: {
            options: {
                type: Array,
                default: () => [],
            },
            value: {
                type: String,
            },
            ajaxurl: {
              type: String,
            },
            onselect: {
              type: String,
            },
            oncomplete: {
              type: String,
            },
            triggerpreselect: {
              type: Boolean,
              default: true
            },
            hideSearch: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Straße wählen'
            },
            noResults: {
                type: String,
                default: 'Keine Einträge verfügbar'
            },
        },
        mounted() {
            var vm = this;
            $(this.$el)
                // init select2
                .select2({
                  dropdownPosition: 'below',
                    ajax: {
                      url: this.ajaxurl,
                      dataType: 'json',
                      delay: 1500,
                      processResults: function (data) {
                        if(data.results.length == 1) vm.selectfirst(data);

                        vm.$emit(vm.oncomplete, event);

                        return data;
                      },
                    },
                    minimumResultsForSearch: this.hideSearch ? Infinity : 5,
                    placeholder: this.placeholder,
                    language: {
                        noResults: () => this.noResults
                    },
                    matcher: function(params, data) {
                      return vm.matchStart(params, data);
                    },
                    // selectOnClose: true,
                })
                /* .on("select2:open", function () {
                  setTimeout(() => {
                    var t = $('.select2-search__field');
                    if(t && t[0]) {
                      t[0].focus();
                    }
                  }, 10);
                }) */
                .val(this.value)
                .trigger("change")
                // emit event on change.
                .on("change", function () {
                  // if(vm.onchange.length)
                  vm.$emit("onchange", event);
                  vm.$emit("input", this.value);
                })
                
            ;

          $(this.$el).on("select2:select", function (event) {
            vm.$emit(vm.onselect, event);
          });

           // on first focus (bubbles up to document), open the menu
          $(document).on('focus', '.select2-selection.select2-selection--single', function (/* e */) {
            // $('.select2-search__field').trigger('focus');
            var t = $('.select2-search__field');
            if(t && t[0]) {
              t[0].focus();
            }
          });

          // steal focus during close - only capture once and stop propogation
          // $('select.select2').on('select2:closing', function (e) {
          //   $(e.target).data("select2").$selection.one('focus focusin', function (e) {
          //     e.stopPropagation();
          //   });
          // });


        // steal focus during close - only capture once and stop propogation
          $('select.select2').on('select2:closing', function (e) {
            $(e.target).data("select2").$selection.one('focus focusin', function (e) {
              e.stopPropagation();
            });
          });

            if(vm.value) {
              // Fetch the preselected item, and add to the control
              var selectbox = $(this.$el);
              $.ajax({
                type: 'GET',
                url: this.ajaxurl + '?q=' + vm.value
              }).then(function (data) {
                // create the option and append to Select2
                var option = new Option(data['results'][0].text, data['results'][0].id, true, true);
                selectbox.append(option).trigger('change');

                // manually trigger the `select2:select` event
                if(vm.triggerpreselect) {
                  selectbox.trigger({
                    type: 'select2:select',
                    params: {
                      data: data
                    }
                  });
                  // selectbox.trigger('change');
                }
              });
            }


        },
      methods: {
        selectfirst: function(selected){
          var selectbox = $(this.$el);
          var option = new Option(selected['results'][0].text, selected['results'][0].id, true, true);
          selectbox.append(option).select2('close').trigger('change');

          if(selectbox.attr('id') != "undefined") this.$emit(this.onselect, {target: {id: selectbox.attr('id')}, params: {data: selected['results'][0]}});
        },
        matchStart: function (params, data) {
          params.term = params.term || '';
          if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
            return data;
          }
          return false;
        }
      },
        watch: {
            value: function (value) {
                // update value
                $(this.$el).val(value).trigger("change");
                // $(this.$el).trigger("change");
            },
            options: function () {
              var vm = this;
                // update options
                $(this.$el).empty().select2({
                    ajax: {
                      url: this.ajaxurl,
                      dataType: 'json',
                      delay: 1500
                      // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                    },
                    minimumResultsForSearch: this.hideSearch ? Infinity : 5,
                    placeholder: this.placeholder,
                    language: {
                        noResults: () => this.noResults
                    },
                    matcher: function(params, data) {
                      return vm.matchStart(params, data);
                    },
                    // selectOnClose: true,
                });
            },
        },
        destroyed: function () {
            $(this.$el).off().select2("destroy");
        },
    };

</script>